import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

@Component({
  selector: 'app-ar-modal',
  templateUrl: './ar-modal.component.html',
  styleUrls: ['./ar-modal.component.scss']
})
export class ArModalComponent implements OnInit {

  	text: string;
  	id: number;

	constructor(public thisModalRef: MatDialogRef<ArModalComponent>
		,@Inject(MAT_DIALOG_DATA) public data: any) { }

	ngOnInit() {
		this.text = this.data.text;
		this.id = this.data.id;
	}

	close(){
		this.thisModalRef.close();
	}

}
